import { ExportType } from '@components'

import { ButtonDropdown, ButtonDropdownProps, NavItem } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { DisabledItemWithTooltip } from './elements/DisabledItemWithTooltip'

interface ReportsExportButtonProps extends Omit<ButtonDropdownProps<ExportType>, 'items'> {
  isPdfItemDisabled?: boolean
  pdfTooltipLabel?: string
}

export const ReportsExportButton = ({
  isPdfItemDisabled = false,
  pdfTooltipLabel,
  ...buttonDropdownProps
}: ReportsExportButtonProps) => {
  const { t } = useTranslation()

  const items: NavItem<ExportType>[] = useMemo(
    () => [
      {
        id: ExportType.Pdf,
        readonly: isPdfItemDisabled && !!pdfTooltipLabel,
        children:
          isPdfItemDisabled && pdfTooltipLabel ? (
            <DisabledItemWithTooltip label={t('export_button.pdf')} tooltipLabel={pdfTooltipLabel} />
          ) : (
            t('export_button.pdf')
          ),
        value: ExportType.Pdf,
      },
      {
        id: ExportType.Csv,
        children: t('export_button.csv'),
        value: ExportType.Csv,
      },
      {
        id: ExportType.Xlsx,
        children: t('export_button.xlsx'),
        value: ExportType.Xlsx,
      },
    ],
    [isPdfItemDisabled, pdfTooltipLabel, t],
  )

  return (
    <ButtonDropdown {...buttonDropdownProps} items={items}>
      {t('export_button.label')}
    </ButtonDropdown>
  )
}
